import React, { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { Helmet } from 'react-helmet'
import '../style/contact.css'


const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        const formData = {
            name: e.target.name.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            requirement: e.target.requirement.value,
        };

        const emailContent = `
            Name: ${formData.name}\n
            Email: ${formData.email}\n
            Phone: ${formData.phone}\n
            Requirement: ${formData.requirement}
        `;

        const emailParams = {
            to_name: 'Recipient Name',
            from_name: formData.name,
            from_email: formData.email,
            message: emailContent,
        };

        emailjs.send('service_s9yl39f', 'template_d1jwppl', emailParams, 'Ef5elHS0NNiPr2U6U')
            .then((result) => {
                console.log('Email successfully sent!', result.text);
                form.current.reset();  // Reset the form fields
                alert('Thank you I will get back to you as soon as possible ! :)');
            })
            .catch((error) => {
                console.error('There was an error sending the email:', error);
                alert('Error during sending mail')
            });
    };
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Get in touch with Umang Ratani, your trusted business consultancy partner, for expert advice and tailored solutions. Reach out today!' />
                <title>Get in Touch with Umang Ratani | Business Consultancy Services</title>
            </Helmet>
            <section id='bgServeNewCt'>
                <div className="container" style={{ textAlign: 'center' }} >
                    <h3 id='animath5' style={{ color: "white", paddingTop: "125px", paddingBottom: '175px' }} className="block-sub__title">Partner to grow</h3>
                </div>
            </section>
            <section className='contactUs'>
                <div className='conatiner' style={{ textAlign: 'center' }}>
                    <h3 style={{ color: "#00415d", paddingTop: "25px" }}>Contact Us</h3>
                </div>
                <div className='container'>
                    <div className='row' >
                        <div className='col' style={{ marginTop: '40px', marginBottom: '175px' }}>
                            <div className='phone' style={{ marginTop: '75px', display: 'flex' }}>
                                <img style={{ marginTop: '15px' }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoaOAd4729IT4l4BO3txtJZdE9Ifv_BED_mXw3U0S-9w&s" width={'40px'} height={'40px'} alt="phone" />
                                <div className='mix' style={{ marginLeft: '20px' }}>
                                    <h6 style={{ color: "#030264" }}>TALK TO OUR CLIENT SUPPORT TEAM</h6>
                                    <h5 style={{ color: 'darkorange' }}>+91-8200858674</h5>
                                </div>
                            </div>
                            <div className='phone' style={{ marginTop: '50px', display: 'flex' }}>
                                <img style={{ marginTop: '15px' }} src='https://www.iconpacks.net/icons/1/free-mail-icon-142-thumb.png' width={'40px'} height={'40px'} alt="mail" />
                                <div className='mix' style={{ marginLeft: '20px' }}>
                                    <h6 style={{ color: "#030264" }}>WRITE TO US ABOUT YOUR NEEDS</h6>
                                    <h5 style={{ color: 'darkorange' }}>growth@umangratani.com</h5>
                                </div>
                            </div>
                            <div className='phone' style={{ marginTop: '50px', display: 'flex' }}>
                                <img style={{ marginTop: '15px' }} src="https://www.svgrepo.com/show/493957/address.svg" width={'40px'} height={'40px'} alt="Adress" />
                                <div className='mix' style={{ marginLeft: '20px' }}>
                                    <h6 style={{ color: "#030264" }}>TALK TO OUR CLIENT SUPPORT TEAM</h6>
                                    <h5 style={{ color: 'darkorange' }}>AUDA Water Tank, Saptak Banglows, SATYAMEV EMINENCE, B/s, Science City Rd, Science City, Sola, Ahmedabad, Gujarat 380060</h5>
                                </div>
                            </div>
                        </div>
                        <div className='col' style={{ marginTop: '55px', marginBottom: '175px', textAlign: "center" }}>
                            {/* <!-- Contact 1 - Bootstrap Brain Component --> */}
                            <h5>Quick response and express delivery guaranteed !!!</h5>
                            <form ref={form} className="form" onSubmit={sendEmail}>
                                <div className='row' id='rowForm' >
                                    <div className="col form-group" id='colForm'>
                                        <label htmlFor="name">Your Name (Required)</label>
                                        <input style={{ border: '2px solid' }} type="text" id="name" name="name" placeholder="Enter your name" required />
                                    </div>
                                    <div className="col form-group">
                                        <label htmlFor="email">Your Email (Required)</label>
                                        <input style={{ border: '2px solid' }} type="email" id="email" name="email" placeholder="Enter your email" required />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone (Optional)</label>
                                    <input style={{ border: '2px solid' }} type="tel" id="phone" name="phone" placeholder="Enter your phone number" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="requirement">Tell Us About Your Requirement</label>
                                    <textarea style={{ border: '2px solid' }} id="requirement" name="requirement" rows="4" placeholder="Describe your needs in detail"></textarea>
                                </div>
                                <button id='btnHvn' type="submit">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact
